import { Rda } from './rda.model';
import { TipoPeriodoCreditoFinanceiro } from './tipo-periodo-credito-financeiro.model'
export class CartaCreditoFinanceiro {

  id: number;
  rda: Rda;
  tipoDeclaracao: boolean;
  isConcordo: boolean;
  tipoPeriodo: TipoPeriodoCreditoFinanceiro;
  isRetificacao: boolean;

  constructor(init?: Partial<CartaCreditoFinanceiro>) {
    Object.assign(this, init);
  }

}
